import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const ICart = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="16"
            viewBox="0 0 22 16"
            fill={props.color ?? '#37474F'}
          >
            <path
              d="M22 0L21.3189 1.77778H19.5507L16.3662 12.4444H4.23042L0 2.66667H15.411L14.894 4.44444H2.75733L5.44958 10.6667H15.0086L18.1546 0H22ZM7.79167 13.3333C7.03267 13.3333 6.41667 13.9307 6.41667 14.6667C6.41667 15.4036 7.03267 16 7.79167 16C8.55067 16 9.16667 15.4036 9.16667 14.6667C9.16667 13.9307 8.55067 13.3333 7.79167 13.3333ZM12.375 13.3333C11.616 13.3333 11 13.9298 11 14.6667C11 15.4036 11.616 16 12.375 16C13.134 16 13.75 15.4036 13.75 14.6667C13.75 13.9307 13.134 13.3333 12.375 13.3333Z"
              fill={props.color ?? '#37474F'}
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default ICart;
